/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type tradeRewardsLevelUpModalRule_QueryVariables = {
    readonly userId: string;
};
export type tradeRewardsLevelUpModalRule_QueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly tradeFirm: {
                readonly rewards: {
                    readonly currentProgram: {
                        readonly programInfo: {
                            readonly code: string | null;
                        } | null;
                    } | null;
                } | null;
            } | null;
            readonly activityFeed: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly serviceId: string | null;
                        readonly type: string | null;
                        readonly status: string | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type tradeRewardsLevelUpModalRule_Query = {
    readonly response: tradeRewardsLevelUpModalRule_QueryResponse;
    readonly variables: tradeRewardsLevelUpModalRule_QueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any), v3 = [
        ({
            "kind": "Literal",
            "name": "elementTypes",
            "value": [
                "TRADE_REWARD_PROGRAM"
            ]
        } as any),
        ({
            "kind": "Literal",
            "name": "first",
            "value": 1
        } as any)
    ], v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "tradeRewardsLevelUpModalRule_Query",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "tradeFirm",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TradeFirmType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "rewards",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TradeFirmRewards",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "currentProgram",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ParentProgram",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "programInfo",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "LoyaltyProgram",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "activityFeed",
                                    "storageKey": "activityFeed(elementTypes:[\"TRADE_REWARD_PROGRAM\"],first:1)",
                                    "args": (v3 /*: any*/),
                                    "concreteType": "ActivityFeedConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ActivityFeedEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ActivityFeedElement",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v5 /*: any*/),
                                                        (v6 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "tradeRewardsLevelUpModalRule_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "tradeFirm",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TradeFirmType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "rewards",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TradeFirmRewards",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "currentProgram",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ParentProgram",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "programInfo",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "LoyaltyProgram",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v7 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        (v7 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "activityFeed",
                                    "storageKey": "activityFeed(elementTypes:[\"TRADE_REWARD_PROGRAM\"],first:1)",
                                    "args": (v3 /*: any*/),
                                    "concreteType": "ActivityFeedConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ActivityFeedEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ActivityFeedElement",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v5 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v7 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                (v7 /*: any*/)
                            ]
                        },
                        (v7 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "tradeRewardsLevelUpModalRule_Query",
            "id": "ferrum/231.0.0-2019-09-05T13:45:49.487Z/tradeRewardsLevelUpModalRule_Query",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'b8860bc020f1ff98f847a9c1f3ce58d4';
export default node;
